import { Typography, Box, Button } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import { PageHeader } from '../components/PageHeader';
import { ProductList } from '../components/ProductList';
import { ProductFormDialog } from '../components/ProductFormDialog';
import { useState } from 'react';
import { CaProduct } from '../services/payments-api.service';
import { useAuth } from '../contexts/AuthContext';
import { Action, canPerformAction } from '../services/permissions.service';

export function ProductsPage() {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');
    const [selectedProduct, setSelectedProduct] = useState<CaProduct | null>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const { role } = useAuth();
    const canEditProducts = canPerformAction(role, Action.editProducts);

    const handleCreateProduct = () => {
        setModalMode('create');
        setSelectedProduct(null);
        setModalOpen(true);
    };

    const handleEditProduct = (product: CaProduct) => {
        setModalMode('edit');
        setSelectedProduct(product);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedProduct(null);
    };

    const handleSaveProduct = () => {
        // Refresh the products list after saving
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <PageHeader currentPath="/products">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ShoppingCartIcon sx={{ fontSize: 28, mt: 0.3, mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h5" component="h1" fontWeight={600}>
                        Products
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {canEditProducts && (
                        <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreateProduct}>
                            Create Product
                        </Button>
                    )}
                </Box>
            </Box>

            <ProductList onEditProduct={handleEditProduct} refreshTrigger={refreshTrigger} />

            <ProductFormDialog
                open={modalOpen}
                onClose={handleCloseModal}
                onSave={handleSaveProduct}
                product={selectedProduct}
                mode={modalMode}
            />
        </PageHeader>
    );
}
